import { render, staticRenderFns } from "./page-item.vue?vue&type=template&id=2b0f80ac"
import script from "./page-item.vue?vue&type=script&lang=js"
export * from "./page-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports